import React, { useEffect, useState } from "react"
import {
  Button,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import { useTranslation } from "react-i18next"

const SensitiveActionOtpModal = ({
  isOpen,
  toggle,
  onConfirm,
  confirming = false,
  title,
}) => {
  const { t } = useTranslation()
  const [otp, setOtp] = useState("")

  useEffect(() => {
    if (isOpen) setOtp("")
  }, [isOpen])

  const handleClose = () => {
    setOtp("")
    toggle()
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (!otp.trim()) return
    onConfirm(otp.trim())
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={handleClose}>
        {title || t("Verify OTP")}
      </ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <p className="text-muted mb-3">
            {t(
              "An OTP has been sent to your email. Enter it to confirm this action."
            )}
          </p>
          <Label className="form-label">{t("OTP")}</Label>
          <Input
            value={otp}
            onChange={e => setOtp(e.target.value.replace(/\D/g, ""))}
            placeholder={t("Enter OTP")}
            maxLength={5}
            autoComplete="off"
            name="sensitive-action-verification-code"
            inputMode="numeric"
            autoFocus
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" type="button" onClick={handleClose}>
            {t("Cancel")}
          </Button>
          <Button color="primary" type="submit" disabled={confirming || !otp}>
            {confirming ? t("Confirming...") : t("Confirm")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default SensitiveActionOtpModal
